import shop from '../../api/orderComment';
import { remove_detail } from '@/commons/hpod';
import { sendSuccessNotice, sendErrorNotice, refreshResource } from '@/commons/utils';
import Vue from 'vue';
const endpoint = 'order_comment'
const viewTitle = 'tin nhắn'

// initial state
const state = {
    loading: false,
    all: {},
    selected: {}
};

// getters
const getters = {};

// actions
const actions = {
    getOrderCommentList({ commit }, param) {
        shop.getOrderCommentList(data => {
            commit('setOrderCommentList', data);
        }, Vue.http, param, this.state.authentication.token);
    },
    putOrderComment({ dispatch }, param) {
        shop.putOrderComment(data => {
            dispatch('getOrderCommentList', {id: param.OrderID, type: param.OrderType, msgArea: param.Type});
        }, Vue.http, param, this.state.authentication.token);
    },
    removeDetail({ commit, dispatch }, id) {
        commit("setLoading", { loading: true });
        remove_detail(endpoint, res => {
            if (res.data.status === false) {
                sendErrorNotice(`Không thể xóa ${viewTitle}.`)
            }
            else {
                sendSuccessNotice(`Đã xóa ${viewTitle} thành công.`)
                refreshResource();
            }
            commit("setLoading", { loading: false });
        }, Vue.http, id, this.state.authentication.token);
    },
};

// mutations
const mutations = {
    setOrderCommentList(state, res) {
        state.all = res.data;
    },
    setLoading(state, { loading }) {
        state.loading = loading;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
